/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiWorkspaceServiceV1AccountsIdErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class GetApiWorkspaceServiceV1AccountsIdErrorResponse extends Error {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: GetApiWorkspaceServiceV1AccountsIdErrorResponseData;

  constructor(err: GetApiWorkspaceServiceV1AccountsIdErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "GetApiWorkspaceServiceV1AccountsIdErrorResponse";
  }
}

/** @internal */
export const GetApiWorkspaceServiceV1AccountsIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1AccountsIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiWorkspaceServiceV1AccountsIdErrorResponse(v);
    });

/** @internal */
export type GetApiWorkspaceServiceV1AccountsIdErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const GetApiWorkspaceServiceV1AccountsIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1AccountsIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiWorkspaceServiceV1AccountsIdErrorResponse
  > = z.instanceof(GetApiWorkspaceServiceV1AccountsIdErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiWorkspaceServiceV1AccountsIdErrorResponse$ {
  /** @deprecated use `GetApiWorkspaceServiceV1AccountsIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiWorkspaceServiceV1AccountsIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1AccountsIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiWorkspaceServiceV1AccountsIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1AccountsIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiWorkspaceServiceV1AccountsIdErrorResponse$Outbound;
}
